module.exports = __webpack_public_path__ + "static/media/thinking.eef2240e.png";